import React from 'react';

const Form = ({ children, onSubmit, className = '', ...props }) => {
  return (
    <form 
      onSubmit={onSubmit} 
      className={`space-y-6 ${className}`} 
      {...props}
    >
      {children}
    </form>
  );
};

const FormGroup = ({ children, className = '', ...props }) => {
  return (
    <div className={`form-group ${className}`} {...props}>
      {children}
    </div>
  );
};

const FormRow = ({ children, className = '', ...props }) => {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 gap-4 ${className}`} {...props}>
      {children}
    </div>
  );
};

Form.Group = FormGroup;
Form.Row = FormRow;

export default Form;
